export function useHelpers() {
  const getCurrentDateInYmdFormat = () => {
    const date = new Date()
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  const getOneWeekBeforeDateInYmdFormat = (date: string) => {
    const [year, month, day] = date.split('-').map(Number)
    const oneWeekBeforeDate = new Date(year, month - 1, day - 6)
    const yearOneWeekBefore = oneWeekBeforeDate.getFullYear()
    const monthOneWeekBefore = String(oneWeekBeforeDate.getMonth() + 1).padStart(2, '0')
    const dayOneWeekBefore = String(oneWeekBeforeDate.getDate()).padStart(2, '0')
    return `${yearOneWeekBefore}-${monthOneWeekBefore}-${dayOneWeekBefore}`
  }

  const getDayBeforeDateInYmdFormat = (date: string) => {
    const [year, month, day] = date.split('-').map(Number)
    const oneDayBeforeDate = new Date(year, month - 1, day - 1)
    const yearOneDayBefore = oneDayBeforeDate.getFullYear()
    const monthOneDayBefore = String(oneDayBeforeDate.getMonth() + 1).padStart(2, '0')
    const dayOneDayBefore = String(oneDayBeforeDate.getDate()).padStart(2, '0')
    return `${yearOneDayBefore}-${monthOneDayBefore}-${dayOneDayBefore}`
  }

  const getCurrentDateTimeInDatetimeLocalFormat = (): string => {
    return new Date().toISOString().substring(0, 16)
  }

  const formatDateTime = (d: string) => {
    const date = new Date(d)
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    const seconds = String(date.getSeconds()).padStart(2, '0')
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
  }

  const formatDate = (d: string | Date) => {
    let date
    if (typeof d === 'string') {
      const [year, month, day] = d.split('-').map(Number)
      date = new Date(year, month - 1, day)
    }
    else {
      date = new Date(d)
    }
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  const generateRandomElementId = (): string => {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
  }

  return {
    generateRandomElementId,
    getCurrentDateInYmdFormat,
    formatDateTime,
    formatDate,
    getCurrentDateTimeInDatetimeLocalFormat,
    getOneWeekBeforeDateInYmdFormat,
    getDayBeforeDateInYmdFormat,
  }
}
